/*
These functions make sure WordPress
and Foundation play nice together.
*/

var mobileCheck = {
	ios: function(){
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	android: function(){
		return navigator.userAgent.match(/Android/i);
	},
	blackBerry: function(){
		return navigator.userAgent.match(/BB10|Tablet|Mobile/i);
	},
	windows: function(){
		return navigator.userAgent.match(/IEMobile/i);
	},
	smartphone: function(){
		return (window.innerWidth <= 384 && window.innerHeight <= 640);
	},
	tablet: function(){
		return (navigator.userAgent.match(/Tablet|iPad|iPod/i) && window.innerWidth <= 1280 && window.innerHeight <= 800);
	},
	all: function(){
		return navigator.userAgent.match(/Android|BlackBerry|Tablet|Mobile|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
	}
};

var userAgent = window.navigator.userAgent;
var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
var isMac = navigator.appVersion.indexOf("Mac")!=-1;
var isBadStockAndroid = (function() {
	// Android stock browser test derived from
	// http://stackoverflow.com/questions/24926221/distinguish-android-chrome-from-stock-browser-stock-browsers-user-agent-contai
	var isAndroid = userAgent.indexOf(' Android ') > -1;
	if (!isAndroid) {
		return false;
	}

	var isStockAndroid = userAgent.indexOf('Version/') > -1;
	if (!isStockAndroid) {
		return false;
	}

	var versionNumber = parseFloat((userAgent.match('Android ([0-9.]+)') || [])[1]);
	// anything below 4.4 uses WebKit without *any* viewport support,
	// 4.4 has issues with viewport units within calc()
	return versionNumber <= 4.4;
})();

var Devices = (function($, mobileCheck){

	var $html = jQuery('html');

	var init = function() {
		initDevices();

		jQuery(window).on('resize.device', 
			function(){
				reset();
				// setTimeout(function(){				
				initDevices();
				// }, 500);			
			}
		);
	}

	function initDevices() {
		// console.log(mobileCheck.all());
		if (mobileCheck.ios()) {
			$html.addClass('ios');
		}
		if (mobileCheck.android()) {
			$html.addClass('android');
		}
		if (mobileCheck.blackBerry()) {
			$html.addClass('blackBerry');
		}
		if (mobileCheck.windows()) {
			$html.addClass('windows');
		}
		if (mobileCheck.smartphone()) {			
			$html.addClass('smartphone');
		}
		// if (mobileCheck.tablet) {			
		// 	$html.addClass('tablet');
		// }
		if (mobileCheck.all()) {
			// console.log('all-devices');	
			$html.addClass('all-devices');
		}
		if (isSafari) {
			$html.addClass('safari');
		}
		// if (md.is('iPhone')) {
		// 	$html.addClass('iPhone');
		// }
		// if (md.is('iPad')) {
		// 	$html.addClass('iPad');
		// }

		var b = document.documentElement;
		b.className = b.className.replace('no-js', 'js');
		b.setAttribute("data-useragent",  navigator.userAgent);
		b.setAttribute("data-platform", navigator.platform );
	}

	var reset = function() {
		// console.log('reset');
		$html.removeClass('ios android blackBerry windows smartphone all-devices');
	}

	return {
		init: init,
		reset: reset
	}

})(jQuery, mobileCheck);

var Setup = (function(MobileDetect){

	var md;

	var init = function() {
		setupOrientation();
		initDevices();

		setupResponsive();

		jQuery(window).on('resize.setup', 
			jQuery.debounce(250, function(){
				setupOrientation();
				resetDevices();
				initDevices();
				setupResponsive();
			})
		); 
	}

	function setupOrientation() {
		if (jQuery(window).width() < jQuery(window).height()) {
		   jQuery('body').addClass('portrait');
		   jQuery('body').removeClass('landscape');
		}
		else {
		   jQuery('body').addClass('landscape');
		   jQuery('body').removeClass('portrait');
		}
	}

	function initDevices() {
        var md = new MobileDetect(navigator.userAgent),        
        grade = md.mobileGrade();
        Modernizr.addTest({
            mobile: !!md.mobile(),
            phone: !!md.phone(),
            tablet: !!md.tablet(),
            mobilegradea: grade === 'A'
        });
    }

    function resetDevices() {
    	delete Modernizr.mobile;
    	delete Modernizr.phone;
    	delete Modernizr.tablet;
    	delete Modernizr.mobilegradea;
    	jQuery('html').removeClass("mobile no-mobile phone no-phone tablet no-tablet mobilegradea");
    }

    function setupResponsive() {
    	// console.log('setupResponsive');
    	// if not mobile or not devices    	
    	if (jQuery('html').hasClass('no-mobile')) {
    		// console.log('no-mobile');
    		// console.log(Foundation.MediaQuery.atLeast('large'));	
    		// console.log(Foundation.MediaQuery.atLeast('medium'));	
    		// console.log(Foundation.MediaQuery.atLeast('small'));	
    		if (Foundation.MediaQuery.atLeast('large')) {
    			// console.log('large');
	    		jQuery('body').removeClass('phone-view tablet-view');
	    		jQuery('html').removeClass('all-devices');
	    	} else if (Foundation.MediaQuery.atLeast('medium')) {
	    		// console.log('medium');
	    		jQuery('body').removeClass('phone-view');
	    		jQuery('body').addClass('tablet-view');
	    		jQuery('html').addClass('all-devices');
	    	} else if (Foundation.MediaQuery.atLeast('small')) {
	    		// console.log('small');
	    		jQuery('body').removeClass('tablet-view');
	    		jQuery('body').addClass('phone-view');
	    		jQuery('html').addClass('all-devices');
	    	}
    	}

    	if (jQuery('html').hasClass('mobile')) { 
			jQuery('body').removeClass('phone-view tablet-view');
    	}
    }

	return {
		init: init
	}

})(MobileDetect);

var Layout = (function($){

	var init = function() {
		initImageFullSide();
	}

	function initImageFullSide() {
		if ($('.image-full-side').length) {			
			calculateImageSize();

			jQuery(window).on('resize.setup', 
				jQuery.debounce(250, function(){
					calculateImageSize();
				})
			);
		}



	}

	function calculateImageSize() {
		if (!$('html').hasClass('phone') && !$('body').hasClass('phone-view')) {
			$('.image-full-side--left').each(function(e, i){
				var width = $(this).width() + $(this).offset().left;
				console.log({
					width: width,
					windowWidth: $(window).width(),
					offsetLeft: $(this).offset().left
				});
				$(this).find('.image-full-side--item').width(width);
			});
			$('.image-full-side--right').each(function(e, i){
				var width = $(window).width() - $(this).offset().left;
				console.log({
					width: width,
					windowWidth: $(window).width(),
					offsetLeft: $(this).offset().left
				});
				// $(this).width(width);
				$(this).find('.image-full-side--item').width(width);
			});
		}
		
	}

	return {
		init: init
	}

})(jQuery);

var Contact = (function($){

	var init = function() {
		initMap();
	}

	function initMap() {
		var $map = $('#map');
		var lat = $map.data('lat');
		var lng = $map.data('lng');
		var zoom = $map.data('zoom');

		var center = { lat: lat, lng: lng };
		var mapOptions = { zoom: zoom, center: center };

		var map = new google.maps.Map( $map[0], mapOptions );

		new google.maps.Marker({
			map: map,
			position: center,
		})
	}
	

	return {
		init: init
	}

})(jQuery);

var Gallery = (function($){

	var init = function() {
		if ($('div[id^="gallery_"]').length) {
			$('div[id^="gallery_"]').each(function(){
		      $(this).unitegallery({
		        // tiles_type: "justified",
		        // lightbox_type: "compact",
		        // theme_enable_preloader: "false"
		      });
		    });
		}
	}

	return {
		init: init
	}

})(jQuery);

jQuery(document).ready(function() {
	
	Devices.init();
	Setup.init();
	objectFitImages(null, {watchMQ: true});

	Layout.init();
	Gallery.init();
	// Contact.init();
}); 